// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-client-integration-tsx": () => import("./../../../src/pages/clientIntegration.tsx" /* webpackChunkName: "component---src-pages-client-integration-tsx" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-session-tsx": () => import("./../../../src/pages/session.tsx" /* webpackChunkName: "component---src-pages-session-tsx" */)
}

